export const Dots = function ({ amount = 3 }) {
  if (amount > 3 && process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.warn('Update your tailwind config to support more than 3 dots.')
  }
  return (
    <div className="flex">
      {[...Array(amount).keys()].map(function (i) {
        const blink = `motion-safe:animate-blink${i === 0 ? '' : 200 * i}`
        return (
          <div className={`${blink} mr-1`} key={i}>
            .
          </div>
        )
      })}
    </div>
  )
}
